import Controller from 'controllers/controller';
import Flickity from "flickity-as-nav-for";
import EventManager from 'tools/event-manager';
import Helpers from 'tools/helpers';

class CarouselController extends Controller {
    constructor(app, element, options = { }) {
        super(app);
        
        this.element = element;
        this.userOptions = options;
        
        this.events = new EventManager({
            bind: this
        });
        
        this.carousel = null;
        this.windowWidth = window.innerWidth;
        
        this.initCarousel();
        this.attachEvents();
    }
    
    getDefaultOptions() {
        return {
            pageDots: true,
            selectedAttraction: 0.015,
            friction: 0.2,
            arrowShape: this.getArrowShape()
        }
    }
    
    getArrowShape() {
        // On smaller devices we use a small chevron to save space
        if (this.app.breakpointController.lt('sm')) {
            return 'M52.29,94.29l1.42-1.43a2.41,2.41,0,0,0,0-3.42L14.27,50,53.71,10.56a2.41,2.41,0,0,0,0-3.42L52.29,5.71a2.42,2.42,0,0,0-3.43,0L6.29,48.29a2.41,2.41,0,0,0,0,3.42L48.86,94.29a2.42,2.42,0,0,0,3.43,0Z';
        }
        
        return 'M50,97A47,47,0,1,1,97,50,47,47,0,0,1,50,97ZM72,41.66H50V28.22a2.28,2.28,0,0,0-3.89-1.61L24.45,48.39a2.25,2.25,0,0,0,0,3.2L46.11,73.37A2.28,2.28,0,0,0,50,71.76V58.34H72a2.29,2.29,0,0,0,2.28-2.28V43.94A2.29,2.29,0,0,0,72,41.66Z';
    }
    
    getFinalOptions() {
        return Object.assign(this.getDefaultOptions(), this.userOptions);
    }
    
    initCarousel() {
        this.carousel = new Flickity(this.element, this.getFinalOptions());
    }
    
    attachEvents() {
        this.events.on(window, 'resize', Helpers.delayedFunction(250, this.onWindowResize, this));
    }
    
    onWindowResize() {
        let width = window.innerWidth;
        
        // Only if width has changed shall we reinstantiate Flickity, otherwise, just trigger a resize.
        // There's a bug with flickity that it sometimes won't resize correctly, and any subsequent calls to .resize
        // fail to make a difference. Only destroying and re-instantiating fixed it.
        // But, on mobile devices, scrolling up and down, causes a resize because of the browser url bar header being
        // hidden as you scroll. Therefore we only reinstantiate if the width has changed.
        if (width !== this.windowWidth) {
            this.carousel.destroy();

            this.initCarousel();
        } else {
            console.log('resize');
            this.carousel.resize();
        }
        
        this.windowWidth = width;
    }
}

export default CarouselController;